<template>
  <Dialog :visible="true" modal :style="{ width: '40rem' }" :breakpoints="{ '640px': '95vw' }" header="تعديل الأنظمة الدراسية" @update:visible="$emit('close')">
    <div class="ds-field-grid">
      <div class="form-field">
        <label class="field-label">تسمية القسم</label>
        <input type="text" class="form-control" v-model="form.label" />
      </div>
      <div class="form-field">
        <label class="field-label">عنوان القسم</label>
        <input type="text" class="form-control" v-model="form.title" />
      </div>
    </div>

    <div class="form-field mt-3">
      <label class="field-label">المراحل</label>
      <div v-for="(stage, i) in form.stages" :key="i" class="hb-stage-row">
        <input type="text" class="form-control hb-col-sm" v-model="stage.icon" placeholder="رمز" />
        <input type="text" class="form-control" v-model="stage.name" placeholder="اسم المرحلة" />
        <input
          type="text"
          class="form-control"
          :value="stage.levels.join('، ')"
          @input="stage.levels = $event.target.value.split('،').map((s) => s.trim()).filter(Boolean)"
          placeholder="السنوات (مفصولة بفاصلة، مثال: أولى ثانوي، ثانية ثانوي)"
        />
        <button class="icon-action-btn icon-action-btn--danger" @click="form.stages.splice(i, 1)"><i class="pi pi-trash"></i></button>
      </div>
      <button class="ds-btn ds-btn--outline ds-btn--sm mt-1" @click="form.stages.push({ icon: '', name: '', levels: [] })">
        <i class="pi pi-plus"></i> إضافة مرحلة
      </button>
    </div>

    <div class="form-field mt-3 hb-visibility">
      <label class="field-label">الحالة</label>
      <InputSwitch v-model="form.is_active" />
    </div>

    <template #footer>
      <button class="btn-cancel" @click="$emit('close')">إلغاء</button>
      <button class="ds-btn ds-btn--primary" :disabled="store.saving" @click="save">
        <i class="pi pi-check"></i> {{ store.saving ? 'جارٍ الحفظ...' : 'حفظ' }}
      </button>
    </template>
  </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';
import InputSwitch from 'primevue/inputswitch';
import Swal from 'sweetalert2';
import { useHomepageSectionStore } from '@/stores/useHomepageSectionStore.js';

export default {
  name: 'AcademicSystemsEditor',
  components: { Dialog, InputSwitch },
  props: { section: { type: Object, required: true } },
  emits: ['close', 'saved'],
  data() {
    const s = this.section.settings || {};
    return {
      form: {
        label: s.label || '',
        title: s.title || '',
        stages: (s.stages?.length ? s.stages : []).map((st) => ({ icon: st.icon || '', name: st.name || '', levels: [...(st.levels || [])] })),
        is_active: !!this.section.is_active,
      },
    };
  },
  computed: {
    store() { return useHomepageSectionStore(); },
  },
  methods: {
    async save() {
      try {
        await this.store.updateSection(this.section.id, {
          settings: { label: this.form.label, title: this.form.title, stages: this.form.stages },
          is_active: this.form.is_active,
        });
        Swal.fire({ icon: 'success', title: 'تم الحفظ', timer: 1400, showConfirmButton: false });
        this.$emit('saved');
      } catch (e) {
        Swal.fire({ icon: 'error', title: e?.response?.data?.message || 'حدث خطأ', timer: 2500, showConfirmButton: false });
      }
    },
  },
};
</script>

<style scoped>
.hb-visibility { display: flex; align-items: center; justify-content: space-between; }
.hb-stage-row { display: grid; grid-template-columns: 70px 1fr 1.5fr 40px; gap: 0.5rem; margin-bottom: 0.5rem; align-items: center; }
.hb-col-sm { max-width: 90px; }
</style>
